export default "__VITE_ASSET__fe11e7ff__"